import { useEffect, useRef } from 'react';
import { Container, Navbar, Nav, Button, Dropdown } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux'
import { Link, NavLink } from 'react-router-dom';
import { userReset } from '../../store/reducerSlice/user';
import Logo from '../common/Logo/Logo';
import styles from './Header.module.css';

const Header = () => {
    const user = useSelector(state => state.user);
    const { userDetail } = user;
    const dispatch = useDispatch();
    const logoutRef = useRef();

    useEffect(() => {
        if(user.invalidJwtToken) {
            // localStorage.removeItem('user');
            // dispatch(userReset())
            logoutRef.current.click();
        }
    }, [user.invalidJwtToken])

    const headerLinks = () => {
        return (
            user.userDetail.userType === "1" ?
                <>
                    <NavLink to="/"
                        className={({ isActive }) => 'btn ' + (isActive ? 'btn-danger' : 'btn-outline-dark')}
                        >
                        Manage Admin
                    </NavLink>
                    <NavLink to="/update-profile"
                        className={({ isActive }) => 'btn ' + (isActive ? 'btn-danger' : 'btn-outline-dark')}
                        >
                        Update Profile
                    </NavLink>
                    <NavLink to="/reset-password"
                        className={({ isActive }) => 'btn ' + (isActive ? 'btn-danger' : 'btn-outline-dark')}
                        >
                        Reset Password
                    </NavLink>
                    <Dropdown.Item ref={logoutRef} href="/" className='btn d-block d-lg-none alignCenter' onClick={()=>{
                            localStorage.removeItem('user');
                            dispatch(userReset())
                            }
                        }>Logout</Dropdown.Item>
                </>
            :
                <>
                    <NavLink to="/"
                        className={({ isActive }) => 'btn ' + (isActive ? 'btn-danger' : 'btn-outline-dark')}
                        >
                        Manage Appointment Plans
                    </NavLink>
                    <NavLink to="/manage-reports"
                        className={({ isActive }) => 'btn ' + (isActive ? 'btn-danger' : 'btn-outline-dark')}
                        >
                        Manage Reports
                    </NavLink>
                    <Dropdown.Item ref={logoutRef} href="/" className='btn d-block d-lg-none alignCenter' onClick={()=>{
                            localStorage.removeItem('user');
                            dispatch(userReset())
                            }
                        }>Logout</Dropdown.Item>
                </>
        )
    }

  return (
    <Navbar className={`${styles.header} ${user?.isAdminLoggedIn && styles.loggedIn}`} expand="lg">
        <Container className='basic'>
            <Navbar.Brand>
                <Link to="/"><Logo /></Link>
            </Navbar.Brand>
            {user?.isAdminLoggedIn && 
                <>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            {
                                headerLinks()
                            }
                        </Nav>
                        <Navbar.Collapse className="justify-content-end d-none">
                            <Dropdown align="end">
                                <Dropdown.Toggle id="dropdown-basic" className={styles.userIcon}>
                                    Hi, {userDetail?.contactName}<br />
                                    <span>
                                        {userDetail?.email}<br />
                                        {/* {userDetail?.userType === "1" ? "Admin" : "Client"} */}
                                        {userDetail?.businessName}
                                    </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item href="/" onClick={()=>{
                                        localStorage.removeItem('user');
                                        dispatch(userReset())
                                        }
                                    }>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Navbar.Collapse>
                    </Navbar.Collapse>
                </>
            }
        </Container>
    </Navbar>
  );
};

export default Header;